// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__voQgs","icon":"SortAdornment_icon__pdBOw","up":"SortAdornment_up__4Q3lS","down":"SortAdornment_down__YLU9g","active":"SortAdornment_active__24nZf"};